import dataServices from "../../services/DataServices";
import { addItem, getAllItems} from '../../services/CsDBService';
import { tickImg, sharepointImg, crossImg } from "../../images/ImageResolver";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const styles = {
  "background-color":"#fafaff"
};

export function textWithIcon(e) {
  let cell = e.cell;
  let content = cell.getContent();
  if (!content) {
    content = document.createElement("div");
    content.className = 'icon-cell';
    content.style.textAlign = "center";
    
    let img = document.createElement("img");
    img.className = 'icon-cell__img';
    img.width = 16;     // tweak as needed
    img.height = 16;    // tweak as needed
    img.decoding = 'async';
    img.loading = 'eager';
    content.appendChild(img);
    cell.setContent(content);
  }

  const value = String(e.data).toLowerCase();
  const imgEl = content.querySelector('.icon-cell__img');
  imgEl.src = (value === 'x') ? tickImg : crossImg;
}

export async function fetchData(tabName){
  async function fetchData(uri){
    let url = API_BASE_URL + uri;
    return dataServices.sendGetRequest(url);
  }

  async function fetchAllData(nextPageKey=null){
    let uri = `get-data?tab=${tabName}&limit=300`;
    if(nextPageKey){
      uri += `&nextPageKey=${nextPageKey}`;
    }
    const res = await fetchData(uri);
    await addItem(tabName, res.data.items);
    if(res.data.hasMore){
      return await fetchAllData(res.data.nextPageKey["content"]);
    }
    return res.data.items;
  }

  const fetchDataAsync = async () => {
    let allData = await getAllItems(tabName);
    if(allData && allData.length > 0){
      return allData;
    }else{
      await fetchAllData();
      return await getAllItems(tabName);
    }
  }
  return await fetchDataAsync()
}

export function gridConfigured(e) {
  // setting header height to accomodate the link and image
  const core = e.detail.api.getCoreGrid();
  const header = core.getSection("title");
  header.setRowHeight(0, 60);
}

export function onCellClicked(e) {
  const grid = document.getElementById('grid');
  let pos = grid.api.getRelativePosition(e);
  if (pos.sectionType === "content") { // Prevent clicking on header section
    let rowIndex = pos.rowIndex;
    let rowDef = grid.api.getRowDefinition(rowIndex);
    
    if (rowDef) { // Prevent clicking on expanded row
      let rowId = rowDef.getRowId();
      let dv = grid.api.getDataView();
      if (!dv.isRowExpansion(rowId)) {
        dv.toggleRowExpansion(pos.rowIndex);
      }
    }
  }
}

export function textwithImg(e){
  let cell = e.cell;
  let content = cell.getContent();
  if(!content || !content._myTextWithImg) {
    content = document.createElement("div");
    content._myTextWithImg = true;
    let link = content._link = document.createElement("a");
    link.href = e.data;
    link.target = "_blank";
    link.style.cursor = "pointer";
    link.style.textAlign = "center";
    link.style.display = "block";
    link.style.width = "100%";
    content.appendChild(link);
    let img = content._img = document.createElement("img");
    img.style.width = "28px";
    img.style.height = "28px";
    img.style.verticalAlign = "middle";
    img.style.cursor = "pointer";
    content._link.appendChild(img);
    content.appendChild(content._link);
  }

  try {
    if(e.data !== null && e.data !== undefined && e.data !== ""){
      cell.setTooltip(e.data);
      content._link.href = e.data;
      content._link.style.pointerEvents = "auto";
      content._img.src = sharepointImg;
    }else{
      cell.setTooltip("No reference document");
      content._link.href = "#";
      content._link.style.pointerEvents = "none";
      content._img.src = crossImg;
    }
  } catch (error) {
    console.error('Error setting tooltip:', error);
  }
  cell.setContent(content);
}